export default function NewChapter() {
  return (
    <section
      className="w-screen min-h-fit flex flex-col px-4 md:px-8 py-10"
      style={{
        background:
          "linear-gradient(180deg, #FFFFFF 0%, rgba(103,119,255,0.09) 100%)"
      }}
    >
      <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center w-full max-w-6xl mx-auto">
        {/* Text Content */}
        <div className="flex-1 flex flex-col items-center md:items-start justify-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-[#121828] mb-4 md:mb-6 text-center md:text-left">
            A New Chapter in decentralized governance.
          </h2>
          <p className="text-lg md:text-xl text-[#414653] mb-4 md:mb-8 max-w-2xl text-center md:text-left">
            XAO DAO was born from the growing demand for transparent, accountable, and community-driven governance.
          </p>
          <p className="text-lg md:text-xl text-[#414653] mb-8 max-w-2xl text-center md:text-left">
            It serves as a neutral coordination layer that enables decentralized decision-making, funding, and long-term ecosystem growth within the XRPL network.
          </p>
        </div>
        {/* Image Content */}
        <div className="flex-1 flex items-center justify-center">
          <img src="/newChapter.png" alt="New Chapter" className="w-full max-w-md" />
        </div>
      </div>
      {/* Box List below text */}
      <div className="flex flex-col md:flex-row gap-8 md:pl-8 mb-20 md:mb-28 max-w-2xl mx-auto md:ml-[calc((100%-1280px)/2+2rem)]">
        {/* Our mission box */}
        <div 
          className="flex flex-col border-l-2 items-start px-5" 
          style={{
            width: 300, 
            height: 61,
            borderImage: 'linear-gradient(to bottom, #1BDFFF 0%, #0098FB 50%, #6777FF 100%) 1'
          }}
        >
          <span
            className="uppercase font-semibold text-[16px] text-[#121828] mb-0"
          >
            Our mission
          </span>
          <span
            className="font-normal text-[16px] leading-[220%] text-[#414653] text-sm"
            style={{width: 346, height: 35}}
          >
            Empower the ecosystem’s core — its people.
          </span>
        </div>
        {/* Transparent by design box */}
        <div 
          className="flex flex-col border-l-2 items-start px-5 md:ml-5" 
          style={{
            width: 317, 
            height: 61,
            borderImage: 'linear-gradient(to bottom, #1BDFFF 0%, #0098FB 50%, #6777FF 100%) 1'
          }}
        >
          <span
            className="uppercase font-semibold text-[16px] text-[#121828] mb-0"
            style={{width: 297, height: 26}}
          >
            Transparent by design
          </span>
          <span
            className="font-normal text-[16px] leading-[220%] text-[#323267] text-sm"
            style={{width: 297, height: 35}}
          >
            Everything is on-chain and auditable.
          </span>
        </div>
      </div>
    </section>
  );
}